import React from 'react';
import { Icon } from 'semantic-ui-react';
import ConfirmModal from '../common/ConfirmModal';

/**
 * DeletionWarningModal - Warns users before deleting items with associated VTO results
 * 
 * @param {boolean} isOpen - Whether the modal is open
 * @param {function} onClose - Callback when modal is closed/cancelled
 * @param {function} onConfirm - Callback when deletion is confirmed
 * @param {string} itemType - Type of item being deleted ('person-image' or 'clothing-item')
 * @param {number} vtoCount - Number of VTO results that will be deleted
 * @param {boolean} isDeleting - Whether deletion is in progress
 * @param {string} error - Error message to display
 */
const DeletionWarningModal = ({
  isOpen,
  onClose,
  onConfirm,
  itemType,
  vtoCount,
  isDeleting = false,
  error = null
}) => {
  // Determine item type display name
  const itemTypeName = itemType === 'person-image' ? 'person image' : 'clothing item';
  
  // Use singular or plural language for VTO results
  const vtoResultText = vtoCount === 1 ? '1 virtual try-on result' : `${vtoCount} virtual try-on results`;

  return (
    <ConfirmModal
      isOpen={isOpen}
      onClose={!isDeleting ? onClose : undefined}
      onConfirm={onConfirm}
      title={`Delete ${itemTypeName}?`}
      titleIconName="warning sign"
      titleIconColor="red"
      confirmText="Delete All"
      cancelText="Cancel"
      variant="danger"
      isLoading={isDeleting}
      loadingText="Deleting..."
      confirmDisabled={isDeleting}
      closeOnOverlay={!isDeleting}
    >
      <p>
        This {itemTypeName} is associated with <strong style={{ color: '#dc2626' }}>{vtoResultText}</strong>.
      </p>
      
      <div className="confirm-modal-warning">
        <Icon name="warning sign" color="orange" style={{ margin: 0, flexShrink: 0 }} />
        <span>
          If you delete this {itemTypeName}, all associated virtual try-on results will also be permanently deleted.
        </span>
      </div>
      
      <p style={{ fontWeight: 500, marginTop: 16 }}>
        Are you sure you want to continue?
      </p>

      {error && (
        <div className="confirm-modal-error">
          <Icon name="warning circle" style={{ margin: 0 }} />
          <span><strong>Deletion Failed:</strong> {error}</span>
        </div>
      )}
    </ConfirmModal>
  );
};

export default DeletionWarningModal;
